import React from 'react';
import {useFormContext} from 'react-hook-form';
import {Button} from '@bonprix/design-system';

export default function RhfSubmitButton({
                                            children,
                                            variant,
                                            disabled,
                                            small,
                                            fullWidth,
                                            loading,
                                            onSubmit
                                        }) {

    const {handleSubmit} = useFormContext();

    return (
        <Button
            variant={variant}
            disabled={disabled}
            small={small}
            contentWidth={!fullWidth}
            loading={loading}
            onClick={handleSubmit(onSubmit)}
        > {children}
        </Button>
    );
}